import { create } from 'zustand';
import type { BuilderState } from '@/types/product';

const defaultCustomer = {
  customerName: '',
  companyName: '',
  email: '',
  phone: '',
  country: '',
};

const defaultProduct = {
  productName: '',
  description: '',
};

const defaultMaterial = {
  material: '',
  finish: '',
  color: '',
};

const defaultDimensions = {
  height: '',
  width: '',
  depth: '',
  weight: '',
};

export const useBuilderStore = create<BuilderState>((set) => ({
  currentStep: 1,
  customer: defaultCustomer,
  product: defaultProduct,
  material: defaultMaterial,
  dimensions: defaultDimensions,
  referenceImage: null,
  referenceImageName: null,
  generatedImages: [],
  selectedImageIndex: 0,
  isGenerating: false,
  isSubmitting: false,
  isSuccess: false,

  setCurrentStep: (step) => set({ currentStep: step }),
  setCustomer: (data) =>
    set((state) => ({ customer: { ...state.customer, ...data } })),
  setProduct: (data) =>
    set((state) => ({ product: { ...state.product, ...data } })),
  setMaterial: (data) =>
    set((state) => ({ material: { ...state.material, ...data } })),
  setDimensions: (data) =>
    set((state) => ({ dimensions: { ...state.dimensions, ...data } })),
  setReferenceImage: (image, name) =>
    set({ referenceImage: image, referenceImageName: name }),
  setGeneratedImages: (images) => set({ generatedImages: images }),
  setSelectedImageIndex: (index) => set({ selectedImageIndex: index }),
  setIsGenerating: (val) => set({ isGenerating: val }),
  setIsSubmitting: (val) => set({ isSubmitting: val }),
  setIsSuccess: (val) => set({ isSuccess: val }),
  resetBuilder: () =>
    set({
      currentStep: 1,
      customer: defaultCustomer,
      product: defaultProduct,
      material: defaultMaterial,
      dimensions: defaultDimensions,
      referenceImage: null,
      referenceImageName: null,
      generatedImages: [],
      selectedImageIndex: 0,
      isGenerating: false,
      isSubmitting: false,
      isSuccess: false,
    }),
}));
